import React from 'react';
import { Calendar, ArrowRight, Check, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const BookingAppointmentsPage = () => {
  const { login } = useAuth();

  const features = [
    'Agendamento automático 24/7',
    'Integração com Calendly',
    'Lembretes por WhatsApp',
    'Confirmação automática',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Calendar className="h-4 w-4" />
                Agendamentos
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Agendamentos</span> automatizados
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Deixe o chatbot agendar consultas, reuniões e compromissos 24/7 sem intervenção humana.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-white rounded-3xl border-2 border-gray-200 p-6">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="h-6 w-6 text-[#3b82f6]" />
                <span className="font-semibold">Agendar consulta</span>
              </div>
              <div className="grid grid-cols-3 gap-2 mb-4">
                {['09:00', '10:00', '11:00', '14:00', '15:00', '16:00'].map((time) => (
                  <button key={time} className="bg-gray-100 hover:bg-[#3b82f6] hover:text-white rounded-lg py-2 text-sm transition-colors">
                    {time}
                  </button>
                ))}
              </div>
              <Button className="w-full bg-[#3b82f6]">Confirmar agendamento</Button>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Automatize seus agendamentos</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default BookingAppointmentsPage;
